import { ELinkButtonVariant, LinkButton } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

interface IProps extends React.HtmlHTMLAttributes<HTMLElement> {
  onClickButton: (data?: any) => any;
}

const AskHostTextButton: React.FC<IProps> = ({ onClickButton }) => {
  const intl = useIntl();

  return (
    <div className="text-center md:items-center">
      <LinkButton
        className={''}
        onClick={onClickButton}
        label={intl.formatMessage({ defaultMessage: 'Ask host a question', id: 'LT64LO' })}
        variant={ELinkButtonVariant.Underline}
      />
    </div>
  );
};

export default AskHostTextButton;
